export default __webpack_public_path__ + "static/media/020-no drinks.bbcf2489.svg";